import { ProfilePhoto } from "@minervaproject/fds";

import { useUserIdsWithCapability } from "hooks/capabilities";
import { useUsersProperties } from "hooks/use_user_properties";
import { CapabilityType } from "shared/types";
import { computeInitials, longDisplayName, profilePhotoUrl, talkTimeForDisplay } from "utils/user";

function DetailedTalkTimeModal() {
  const users = Object.values(useUsersProperties(["breakout_talk_time", "classroom_talk_time"]));
  const canParticipateInClassUserIds = useUserIdsWithCapability(
    CapabilityType.CAN_PARTICIPATE_IN_CLASS,
  );
  const filteredUsers = users
    .filter((user) => canParticipateInClassUserIds.includes(user.id))
    .toSorted((a, b) => a.first_name.localeCompare(b.first_name));

  return (
    <div className="vertical-scroll" style={{ maxHeight: "420px" }} data-testid="talk-time-modal">
      <table className="fds-table">
        <thead>
          <tr>
            <th className="col-6">Student</th>
            <th className="col-2">Main Class</th>
            <th className="col-2">Breakouts</th>
            <th className="col-2">Attendance</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((user) => (
            <tr key={user.id}>
              <td>
                <div className="flex items-center">
                  <ProfilePhoto
                    className="mr2"
                    size="md"
                    src={profilePhotoUrl(user)}
                    initials={computeInitials(user)}
                  />
                  <span className="truncate">{longDisplayName(user)}</span>
                </div>
              </td>
              <td>{talkTimeForDisplay(user.classroom_talk_time)}s</td>
              <td>{talkTimeForDisplay(user.breakout_talk_time)}s</td>
              <td>{user.is_present ? "Present" : "Not present"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export { DetailedTalkTimeModal };
